import * as types from './additionalInformation.types'

const initialState = {
	isLoading: false,
	isSuccess: false,
	additionalInformation: [],
	permissions: {},
}

export const reducer = (state = initialState, action) => {
	switch (action.type) {
		case types.TOGGLE_LOADING:
			return {
				...state,
				isLoading: action.payload,
			}
		case types.TOGGLE_SUCCESS:
			return {
				...state,
				isSuccess: action.payload,
			}
		case types.SET_ADDITIONAL_INFORMATION:
			return {
				...state,
				additionalInformation: action.payload,
			}
		case types.SET_PERMISSIONS:
			return {
				...state,
				permissions: action.payload,
			}
		default:
			return state
	}
}
